import styled from "styled-components";

export const StyledContainer = styled.main`
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px;
`;